// import { HttpInterceptorFn } from '@angular/common/http';

// export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
//   // Check if we are in the browser environment (not SSR)
//   if (typeof window !== 'undefined' && window.localStorage) {
//     const user = JSON.parse(localStorage.getItem('Admin_User') || '{}')
//     const isExcluded = req.url.includes('/auth/login') || req.url.includes('/auth/signup');
//     if (!isExcluded && user.data.token) {
//       // Add Authorization header if token exists
//       const modifiedRequest = req.clone({
//         setHeaders: {
//           Authorization: `Bearer ${user.data.token}`,
//         },
//       });
//       return next(modifiedRequest);
//     }
//   }

//   // Proceed with the request if no token or not in the browser
//   return next(req);
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) return next(req);

  const excluded = ['/auth/login', '/auth/signup', '/auth/refresh'];
  if (excluded.some(url => req.url.includes(url))) return next(req);

  try {
    const raw = localStorage.getItem('Admin_User');
    if (!raw) return next(req);

    const user = JSON.parse(raw);

    // ✅ Safe optional chaining — no crash if data/token is missing
    const token = user?.data?.token ?? user?.data?.accessToken ?? null;
    if (!token) return next(req);

    return next(
      req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  } catch {
    // Corrupted localStorage value — skip token
    return next(req);
  }
};